import fetch from '@/api/fetch'

/**
 * 退款/退货列表
 */
export function getRefundListReq(params) {
  return fetch({
    showErrorPage: true,
    url: '/my/refund/list',
    params
  })
}

/**
 * 退款/退货详情
 */
export function getRefundDetailReq(params) {
  return fetch({
    showErrorPage: true,
    url: '/my/refund/detail',
    params
  })
}

/**
 * 退款/退货申请页
 */
export function getRefundApplyReq(params) {
  return fetch({
    showErrorPage: true,
    url: '/my/refund/apply',
    params
  })
}

/**
 * 新退款、退货申请页
 */
export function getRefundApplyQueryReq(params) {
  return fetch({
    showErrorPage: true,
    url: '/v2/my/refund/applyQuery',
    method: 'post',
    params
  })
}

/**
 * 提交退款/退货
 */
// export function submitRefundReq(data) {
//   return fetch({
//     url: '/my/refund/submit',
//     method: 'post',
//     params: data
//   })
// }

/**
 * 适配新退款退货 提交退款/退货
 */
export function submitRefundReq(data) {
  return fetch({
    url: '/v2/my/refund/applySubmit',
    setCsrfToken: true,
    method: 'post',
    params: data
  })
}

export function refundSubmit(data) {
  return fetch({
    url: '/v2/my/refund/refundSubmit',
    setCsrfToken: true,
    method: 'post',
    params: data
  })
}

export function addCartReq(params) {
  return fetch({
    url: '/shopCart/addCommodity',
    method: 'POST',
    data: params
  })
}

/**
 * 提交退款/退货凭证
 */
export function voucherSubmitReq({ orderNo, shipExpress, trackNo, refundNo, mobilePhone, tempTerminal }) {
  return fetch({
    url: '/my/refund/voucherSubmit',
    method: 'post',
    setCsrfToken: true,
    params: {
      orderNo,
      shipExpress,
      trackNo,
      refundNo,
      mobilePhone,
      tempTerminal
    }
  })
}

/**
 * 取消申请
 */
export function cancelReq({ orderNo, refundNo, refundType }) {
  return fetch({
    url: '/v2/my/refund/cancel',
    method: 'post',
    setCsrfToken: true,
    params: {
      orderNo,
      refundNo,
      refundType
    }
  })
}

// 退货物流查询
export function queryRefundExpress(params) {
  return fetch({
    showErrorPage: true,
    url: '/my/refund/queryOrderPackageExpress',
    setCsrfToken: true,
    params
  })
}
/**
 * 检查是否允许退款/退货
 */
export function checkRefundApplyReq(params) {
  return fetch({
    url: '/my/refund/checkApply',
    params
  })
}

/**
 * 根据物流单号查询物流公司
 * 返回快递100 code
 */
export function getExpressCode(params) {
  return fetch({
    url: '/v2/my/refund/express/autoNumber',
    method: 'post',
    params
  })
}
/**
 * 计算退回商品
 */
export function calcRefundCommodityReq(params) {
  return fetch({
    url: '/v2/my/refund/calcRefundCommodity',
    method: 'post',
    params
  })
}
